import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import ServitiLogo from '../components/common/ServitiLogo';

const WelcomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, requiresTenantSelection, memberships } = useAuthStore();
  const needsWorkspacePick = Boolean(
    isAuthenticated &&
    (requiresTenantSelection || (!user?.tenant_id && Array.isArray(memberships) && memberships.length > 1))
  );

  const handleContinue = () => {
    if (!isAuthenticated) {
      navigate('/auth/login');
      return;
    }
    if (needsWorkspacePick) {
      navigate('/auth/login');
      return;
    }
    if (user?.tenant_id) {
      navigate(`/t/${user.tenant_id}/get-started`);
      return;
    }
    if (user?.is_superuser || user?.role === 'superadmin') {
      navigate('/platform/dashboard');
      return;
    }
    navigate('/auth/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <ServitiLogo alt="Serviti AI Platform" className="mx-auto h-20" />
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Welcome to Serviti AI!
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Let's get started with exploring the platform.
          </p>
        </div>
        <div>
          <button
            onClick={handleContinue}
            className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {needsWorkspacePick ? 'Choose Workspace' : isAuthenticated ? 'Continue to Dashboard' : 'Sign In'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
